var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-img',{attrs:{"src":_vm.getImg,"height":_vm.height,"width":_vm.width,"contain":""},on:{"click":_vm.onClick}})}
var staticRenderFns = []

export { render, staticRenderFns }